import React, { useState } from 'react';
import { connect } from 'react-redux';
import classnames from 'classnames';
import styles from './StudyMonitors.scss';
import lodash from 'lodash';
import { useImmer } from 'use-immer';
import { PageTitle, PageDescription, } from 'components/common/Study/PageComponents';
import { Button, BUTTON } from 'components/common/Button/Button';
import AddMonitorPanel from './AddMonitorPanel';
import { binderInstitutionIdSelector } from 'common/selectors';
import { Monitors } from 'components/common/Study/ListItemCards/StudyMonitorCard';
import {
    waitingForLoadExternalUsers,
    removeStudyMonitor,
} from 'pages/studyOverview/actions/studySettings';
import { LoadingStatus } from 'components/common/LoadingStatus/LoadingStatus';
import { addOrEditStudyMonitor } from 'pages/studyOverview/actions/studySettings';
import { getTimezoneOffset } from 'common/selectors/index';
import { UserCanManageStudyMonitorsOld } from 'common/permissions/components/actionButton';
import { RemoveStudyTeamModal } from 'pages/studyOverview/containers/StudySettings/Settings/StudySettingsTeamV2';
import { STUDY_USER_TYPE } from 'components/common/Study/StudyTeamMemberForm';
import * as dateTimeUtils from 'common/util/dateTime';

export const StudyMonitors = (props) => {
    const {
        addOrEditStudyMonitor,
        binderId,
        institutionId,
        loadingStudyMonitors,
        studyMonitors,
        timezoneOffset,
        waitingForLoadExternalUsers,
        removeStudyMonitor,
    } = props;

    const [isAddPanelShowing, showAddPanel] = useState(false);
    const [monitorToEdit, setMonitorToEdit] = useImmer({});
    const [selectedUser, setSelectedUser] = useState({});
    const [showModal, setShowModal] = useState(false);

    const addMonitorToStudy = externalUser => {
        addOrEditStudyMonitor(
            {
                firstName: externalUser.firstName,
                lastName: externalUser.lastName,
                displayName: `${externalUser.firstName} ${externalUser.lastName}`,
                emailAddress: externalUser.emailAddress,
            },
            binderId,
            institutionId,
            dateTimeUtils.formatDateAndTimeForSave(externalUser.startDate, externalUser.startTime, timezoneOffset),
            dateTimeUtils.formatDateAndTimeForSave(externalUser.endDate, externalUser.endTime, timezoneOffset),
            {
                notify: externalUser.notify,
                edit: !lodash.isEmpty(monitorToEdit),
            },
        );

        showAddPanel(false);
        waitingForLoadExternalUsers(true);
        setMonitorToEdit(draft => draft = {});
    };

    const editMonitor = monitor => {
        setMonitorToEdit(draft => draft = monitor);
        showAddPanel(true);
    };
    const SecuredAddMonitorButton = UserCanManageStudyMonitorsOld(AddMonitorButton);

    return (
        <div className={
            classnames(
                styles.studyMonitorContainer,
                { [styles.panelOpen]: isAddPanelShowing }
            )}
        data-cy="StudyMonitors"
        >
            <PageTitle>Study Monitors</PageTitle>
            <PageDescription>Monitors have view-only access to Studies during the delegated window of access.</PageDescription>
            <SecuredAddMonitorButton
                className={styles.addMonitorButton}
                onClick={() => {
                    showAddPanel(true);
                }}
                data-cy="StudyMonitors-SecuredAddMonitorButton"
            />
            {loadingStudyMonitors
                ? <LoadingStatus
                    actionLabel={'loading'}
                    itemName={'Study Monitors'}
                    filterQuery={false}
                    loading
                />
                : <Monitors
                    isEditable={true}
                    onEdit={editMonitor}
                    showAddPanel={showAddPanel}
                    studyMonitors={studyMonitors}
                    setSelectedUser={setSelectedUser}
                    setShowModal={setShowModal}
                />
            }
            {isAddPanelShowing && <AddMonitorPanel
                dismiss={isAddPanelShowing}
                monitorToEdit={monitorToEdit}
                onAction={addMonitorToStudy}
                onDismiss={() => {
                    setMonitorToEdit(draft => draft = {});
                    showAddPanel(false);
                }}
            />}
            <RemoveStudyTeamModal
                setShowModal={setShowModal}
                showModal={showModal}
                selectedUser={selectedUser}
                userType={STUDY_USER_TYPE.MONITOR}
                removeUser={removeStudyMonitor}
            />
        </div>
    );
};

export const AddMonitorButton = (props) => (
    <div data-cy="StudyMonitors-btn">
        <Button
            className={props.className}
            bgcolor={BUTTON.BGCOLOR.BLUE}
            color={BUTTON.COLOR.WHITE}
            onClick={props.onClick}
            data-cy="StudyMonitors-Add"
        >
            Add Study Monitor
        </Button>
    </div>
);

export default connect(state => {
    const binderId = lodash.get(state, 'binder.id', {});
    const institutionId = binderInstitutionIdSelector(state);
    const studyMonitors = lodash.get(state, 'externalUsersForStudy', []);
    const loadingStudyMonitors = lodash.get(state, 'externalUsersForStudyLoading', false);
    const timezoneOffset = getTimezoneOffset(state);

    return {
        binderId,
        institutionId,
        loadingStudyMonitors,
        studyMonitors,
        timezoneOffset,
    };

}, {
    addOrEditStudyMonitor,
    waitingForLoadExternalUsers,
    removeStudyMonitor,
})(StudyMonitors);
